global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;

import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

createApp(App).use(router).use(store).mount('#app')
